module.exports = __webpack_public_path__ + "static/media/p7ru.cfcefdbf.pdf";